var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.9827,
    height: 36.8873,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 36.8873,
    opacity: 0,
    width: 36.9827,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.725 24.9068C18.4718 24.9068 12.1245 18.7615 12.1245 8.83641C12.1245 6.05461 12.5714 3.64289 13.2785 2.21344C13.5178 1.72922 13.5647 1.4843 13.5647 1.15688C13.5647 0.616877 13.0699 0 12.3916 0C12.251 0 11.9107 0.046875 11.441 0.214219C4.72641 2.91774 0 10.0437 0 17.6869C0 28.748 8.04 36.8114 19.1011 36.8114C26.9449 36.8114 33.4556 32.6161 36.3919 25.8788C36.5916 25.4398 36.6312 25.0889 36.6312 24.907C36.6312 24.2142 36.0556 23.7607 35.5406 23.7607C35.2617 23.7607 35.0564 23.7841 34.6732 23.9353C33.2627 24.5084 30.9192 24.9068 28.725 24.9068ZM2.54016 17.5898C2.54016 11.6986 5.6836 6.09095 10.6591 3.15305C10.0296 4.90266 9.6975 6.92204 9.6975 9.05555C9.6975 20.4649 16.7037 27.2852 28.3765 27.2852C30.2991 27.2852 31.9936 27.0614 33.5316 26.5223C30.6877 31.3411 25.2108 34.2874 19.1981 34.2874C9.57446 34.2874 2.54016 27.2459 2.54016 17.5898Z",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.039801a8f41a11256cf0552c6ee8678a.svg";
export { ForwardRef as ReactComponent };